// extracted by mini-css-extract-plugin
export default {"grid":"Skills_grid__640QC","group":"Skills_group__Q0xHh","groupTitle":"Skills_groupTitle__08MiH","groupIndex":"Skills_groupIndex__Q9kND","items":"Skills_items__hMQZ3"};